var _defs, _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWashingMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6fa59;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.65,
    y: 85.92,
    width: 13.05,
    height: 13.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 94.57,
    y: 85.92,
    width: 13.05,
    height: 13.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.22,226.26c-.72-3-1.22-6.78-1.49-11.22v-.04c-.18-2.64-.32-5.42-.43-8.53-.08-1.8-.13-3.71-.17-5.89-.1-4.9-.15-9.25-.15-12.9v-63.57l-.02-.48c-.79-10.7-2.94-20-6.4-27.64-1.53-3.4-3.28-6.55-5.17-9.33-3.92-5.9-8.75-10.87-14.34-14.78-8.03-5.64-17.25-9.65-27.41-11.93-9.7-2.13-20.32-3.21-31.56-3.21-7.47,0-15.92,.61-25.12,1.8-9.39,1.24-18.45,2.87-26.91,4.83-8.81,1.99-16.4,4.14-22.56,6.39l-3.21,1.17-1.89,7.21,.37,1.57c.75,3.23,1.28,7.69,1.57,13.26,.3,5.73,.51,11.83,.64,18.11,.09,6.58,.14,11.36,.14,15.05v61.02c0,6.07,.52,12.07,1.56,17.81l.07,.38c1.82,10.25,7.1,19.64,14.88,26.45,8.37,7.4,19.14,11.48,30.34,11.48h55.49c13,0,24.28-.59,33.5-1.74,9.48-1.15,17.62-2.96,24.19-5.39l4.26-1.58v-7.55l-.18-.75Zm-29.87,2.32c-8.71,1.09-19.44,1.65-31.9,1.65h-55.49c-8.01,0-15.71-2.91-21.72-8.23-5.64-4.94-9.44-11.77-10.7-19.22l-.1-.55v-.02c-.85-4.85-1.28-9.91-1.28-15.05v-61.02c0-3.75-.04-8.59-.14-15.27-.13-6.45-.35-12.7-.66-18.56-.23-4.48-.62-8.41-1.15-11.74,4.8-1.54,10.4-3.04,16.74-4.47,8.09-1.87,16.74-3.42,25.7-4.61,8.63-1.12,16.51-1.69,23.42-1.69,10.29,0,19.97,.98,28.73,2.9,8.46,1.89,16.11,5.21,22.74,9.87,4.26,2.98,7.95,6.79,11,11.38,1.5,2.2,2.88,4.69,4.1,7.41,2.8,6.19,4.57,13.93,5.26,22.99v63.33c0,3.75,.05,8.18,.16,13.16,.04,2.26,.1,4.29,.18,6.15,.11,3.19,.26,6.09,.45,8.87,.22,3.52,.57,6.74,1.05,9.61-4.7,1.32-10.19,2.36-16.4,3.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150,109.68c-30.57,0-55.43,24.87-55.43,55.43s24.87,55.44,55.43,55.44,55.43-24.87,55.43-55.44-24.87-55.43-55.43-55.43Zm0,97.82c-23.37,0-42.38-19.01-42.38-42.38s19.01-42.38,42.38-42.38,42.38,19.01,42.38,42.38-19.01,42.38-42.38,42.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMachine);
export default __webpack_public_path__ + "static/media/washingMachine.82dafcc53cc1e914f0f81db6d253ab70.svg";
export { ForwardRef as ReactComponent };